export const PRICE_GRID_MARKET_DATA_COLLECTION_PATH = 'marketData';

export const PRICE_GRID_MARKET_DATA_COLUMN_INITIAL_WIDTH = 350;

export const PRICE_GRID_MARKET_DATA_COLUMN_TYPE = 'securityMarketData';
export const PRICE_GRID_CUSTOMER_MARKET_DATA_COLUMN_TYPE = 'customerSecurityMarketData';
